<div class="container-fluid mt-4">
    <h4 class="mb-3 "><i class="fi fi-rr-newspaper"></i> სლაიდი </h4>
    <div class="row">
        <div class="col-md-3"> 
          <button class="btn btn-primary" (click)="add()">
              დამატება 
          </button>
        </div>
    </div>


    <div class="row g-4">
      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>
    </div>

    <div *ngIf="!load && (!data || data.length === 0)">
      ინფორმაცია ცარიელია
    </div>

    <div *ngIf="!load" 
        cdkDropList 
        [cdkDropListData]="data" 
        (cdkDropListDropped)="drop($event)" 
        class="list-group mt-3">

      <div *ngFor="let item of data; let i = index" 
          cdkDrag 
          class="list-group-item mb-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <span class="me-3">{{ i + 1 }}</span>
          <img *ngIf="item.image" src="{{url}}/carusel/{{item.image}}" 
              class="square-img me-3">
          <span class="truncate-text">{{ item.title }}</span>
        </div>
        <div class="d-flex">

          <button *ngIf="loadDeleteId !== item.id" (click)="delete(item)" class="btn text-danger border btn-sm">
            <i *ngIf="loadDeleteId !== item.id" class="fi fi-rr-trash"></i>
            <app-spinner *ngIf="loadDeleteId === item.id" [loading]="true"></app-spinner>
          </button>


          <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="edit(item)">
            <i class="fi fi-rr-pencil"></i>
          </button>
        </div>
      </div>

    </div>

</div>


<ng-template #formModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <span *ngIf="isEdit">სლაიდის რედაქტირება</span>
      <span *ngIf="!isEdit">სლაიდის დამატება</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

      <form [formGroup]="form">


        <!-- <div class="form-floating mb-3">
          <textarea class="form-control" formControlName="description_ka" rows="2"></textarea>
          <label for="description_ka">აღწერა (KA)</label>
        </div>
        <div class="form-floating mb-3">
          <textarea class="form-control" formControlName="description_en" rows="2"></textarea>
          <label for="description_en">აღწერა (EN)</label>
        </div>
        <div class="form-floating mb-3">
          <textarea class="form-control" formControlName="description_ru" rows="2"></textarea>
          <label for="description_ru">აღწერა (RU)</label>
        </div> -->

        <div class="mb-3">
          <label for="description_ka">აღწერა (KA)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_ka"
          ></editor>
        </div>

        <div class="mb-3">
          <label for="description_en">აღწერა (EN)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_en"
          ></editor>
        </div>

        <div class="mb-3">
          <label for="description_ru">აღწერა (RU)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_ru"
          ></editor>
        </div>

        <div class="form-floating mb-3">
          <input type="text" class="form-control" formControlName="btn_ka" id="btn_ka" placeholder="">
          <label for="btn_ka">ბტონი (KA)</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" formControlName="btn_en" id="btn_en" placeholder="">
          <label for="btn_en">ბტონი (EN)</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" formControlName="btn_ru" id="btn_ru" placeholder="">
          <label for="btn_ru">ბტონი (RU)</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" formControlName="link" id="link" placeholder="">
          <label for="link">ბმული</label>
        </div>

        <div class="mb-3">
          <label>ადგილმდებარეობა</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tmp" id="tmpLeft" value="left">
            <label class="form-check-label" for="tmpLeft">მარცხენა </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tmp" id="tmpRight" value="right">
            <label class="form-check-label" for="tmpRight">მარჯვენა</label>
          </div>
        </div>

       <img *ngIf="form.get('image').value" src="{{url}}/carusel/{{form.get('image').value}}">

      <div class="form-floating mt-3">
              <app-upload
              [uploadPath]="'carusel'"
              (fileUploaded)="onFileUploaded($event)"
             >
            </app-upload>   
          </div>
        
       

      </form>

  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="save(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner> 
      <span *ngIf="isEdit">შენახვა</span>
      <span *ngIf="!isEdit">დამატება</span>
    </button>
  </div>
</ng-template>


